import { useState, useRef, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";

// Reusable across any module that needs a fast, searchable customer
// picker. Falls back to the full customerList (from redux) when the
// search box is empty, and hits /customer/search only while the user
// is actively typing - keeping dropdowns fast even with 5,000+
// customers.
export function useCustomerSearch(customerList) {
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerLoading, setCustomerLoading] = useState(false);
  const debounceRef = useRef(null);

  const mapToOptions = (list) =>
    list?.map((item) => ({
      value: item.customer_id,
      label: `${item.customer_name} - ${item.customer_mobile}`,
      key: item.customer_id,
    })) || [];

  // Keep options in sync if customerList itself changes (e.g. after
  // a fresh redux load) while the search box is empty.
  useEffect(() => {
    setCustomerOptions(mapToOptions(customerList));
  }, [customerList]);

  const searchCustomers = (searchText = "") => {
    clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(async () => {
      if (!searchText.trim()) {
        setCustomerOptions(mapToOptions(customerList));
        return;
      }

      try {
        setCustomerLoading(true);
        const res = await axios.get("/customer/search", {
          params: { search: searchText },
        });
        setCustomerOptions(mapToOptions(res.data?.data));
      } catch (err) {
        toast.error(err?.message || "Customer search failed");
      } finally {
        setCustomerLoading(false);
      }
    }, 400);
  };

  return { customerOptions, customerLoading, searchCustomers };
}